/**
* Created For: 地图组件
* this.$emit("viewDetails",this.curActivePoint)  查看具体终端详情
* this.$emit("positionArea",areaNameObj)  定位点的省市区名称
* Author: chenLiYan.
* Date: 2018/11/30 0030 14:40.
*/
<template>
  <div class="map-wrap">
    <el-amap
      class="amap-box"
      ref="map"
      :vid="'aMapTarget'"
      :center="mapConfig.center"
      :zooms="mapConfig.zooms"
      :zoom="mapConfig.zoom"
      :events="mapEvents"
      :plugin="plugin"
      :mapStyle="mapStyle">
      <!--<el-amap-marker-->
      <!--v-for="(item, index) in markerList"-->
      <!--:key="index"-->
      <!--:position="[item.longitude, item.latitude]"-->
      <!--:vid="index"-->
      <!--:label = "{ content:index,offset:[18,-12] }"-->
      <!--&gt;-->
      <!--</el-amap-marker>-->
    </el-amap>
  </div>
</template>

<script>
// 地图样式map
// function MyCanvasRender(pointSimplifierIns, opts) {
//     //直接调用父类的构造函数
//     MyCanvasRender.__super__.constructor.apply(this, arguments);
// }
// import { asyncSearchClientPage,asyncSearchClientMarker,asyncGetClientInfo,asyncGetMaxTime } from "@/api/clientSearch"
import { asyncGetAreaInfo } from '@/api/area'
const mapStyle = {
  '1': 'normal',
  '2': 'dark',
  '3': 'light',
  '4': 'whitesmoke',
  '5': 'fresh',
  '6': 'grey',
  '7': 'graffiti',
  '8': 'macaron',
  '9': 'blue',
  '10': 'darkblue',
  '11': 'wine'
}
export default {
  name: 'VMap',
  components: {},
  props: {
    markerList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    const self = this
    return {
      loading: false,
      // 地图配置相关
      mapConfig: {
        mapStyle: 4,
        center: [116.30946, 39.937629], // 地图初始化中心点
        zooms: [3, 19], // 地图可缩放级别范围
        zoom: 4 // 初始缩放级别
      },
      // 当前定位点所属省市区code
      positionArea: {
        provinceCode: '',
        cityCode: '',
        districtCode: ''
      },
      // 地图插件
      plugin: [
        {
          pName: 'Geolocation', // 定位
          buttonPosition: 'RB',
          showCircle: false,
          events: {
            init (o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition(() => {})
            },
            // 定位成功时触发此事件
            complete (result) {
              if (result && result.position) {
                // getMyPosition获取我的位置坐标，用于导航
                self.$emit('getMyPosition', [result.position.lng, result.position.lat])
                self.mapConfig.zoom = 14
                self.$nextTick(() => {
                  if (result.addressComponent && result.addressComponent.adcode) {
                    // 获取当前定位地区信息
                    asyncGetAreaInfo(result.addressComponent.adcode).then(res => {
                      if (res.code === 1) {
                        const areaInfo = res.data.nodeInfo
                        if (areaInfo.level === 3) {
                          self.positionArea.districtCode = areaInfo.code
                          self.positionArea.provinceCode = areaInfo.provinceCode
                          self.positionArea.cityCode = areaInfo.cityCode
                          self.$emit('positionAreaName', {
                            districtName: areaInfo.name,
                            cityName: areaInfo.cityName,
                            provinceName: areaInfo.provinceName,
                            cityCode: areaInfo.cityCode.toString(),
                            provinceCode: areaInfo.provinceCode,
                            districtCode: areaInfo.code
                          })
                        }
                      } else {
                        self.$emit('positionAreaName', {
                          districtName: result.addressComponent.district,
                          cityName: result.addressComponent.city,
                          provinceName: result.addressComponent.province,
                          cityCode: result.addressComponent.adcode.toString().substr(0, 4) + '00',
                          provinceCode: result.addressComponent.adcode.toString().substr(0, 2) + '0000',
                          districtCode: result.addressComponent.adcode
                        })
                        self.positionArea.districtCode = result.addressComponent.adcode
                        self.positionArea.provinceCode = parseInt(result.addressComponent.adcode.toString().substr(0, 2) + '0000')
                        self.positionArea.cityCode = parseInt(result.addressComponent.adcode.toString().substr(0, 4) + '00')
                      }
                      self.$emit('positionEnd', Object.assign(self.positionArea, {
                        lat: result.position.lat,
                        lng: result.position.lng
                      }))
                    }).catch(() => {
                      self.$emit('positionAreaName', {
                        districtName: result.addressComponent.district,
                        cityName: result.addressComponent.city,
                        provinceName: result.addressComponent.province,
                        cityCode: result.addressComponent.adcode.toString().substr(0, 4) + '00',
                        provinceCode: result.addressComponent.adcode.toString().substr(0, 2) + '0000',
                        districtCode: result.addressComponent.adcode
                      })
                      self.positionArea.districtCode = result.addressComponent.adcode
                      self.positionArea.provinceCode = parseInt(result.addressComponent.adcode.toString().substr(0, 2) + '0000')
                      self.positionArea.cityCode = parseInt(result.addressComponent.adcode.toString().substr(0, 4) + '00')
                      self.$emit('positionEnd', Object.assign(self.positionArea, {
                        lat: result.position.lat,
                        lng: result.position.lng
                      }))
                    })
                  }
                })
              }
            },
            // 定位失败时
            error (err) {
              self.$emit('positionError', err)
              window.GlobalVue.$createToastNew({
                txt: '定位失败！'
              }).show()
            }
          }
        },
        {
          pName: 'Scale',
          position: 'RB'
        } // 标尺
        //                    { pName: 'ToolBar' }    // 缩放工具
      ],
      // 地图事件
      mapEvents: {
        'click': () => {
          this.$emit('moveStart')
        },
        'movestart': () => {
          this.$emit('moveStart')
        },
        'moveend': () => {
          this.$emit('moveEnd')
        },
        'zoomend': () => {
          this.$emit('zoomEnd')
        }
      },
      // 海量点实例
      pointSimplifierIns: null,
      // 点颜色
      pointColor: {
        covered: '#507ede', // 已覆盖
        uncover: '#ef608b', // 未覆盖
        active: '#ff9126' // 已选中
      },
      // 当前查看的活动点
      curActivePoint: {},
      // 行政区域查询对象
      districtSearch: null,
      // 行政区域边界坐标集合
      polygons: []
    }
  },
  computed: {
    mapStyle () {
      return 'amap://styles/' + (this.mapConfig.mapStyle ? mapStyle[this.mapConfig.mapStyle] : mapStyle['4'])
    }
  },
  watch: {
    // 数据变更时
    markerList (val) {
      // 数据变化时，重绘海量点
      this.setMarkerData(val)
    }
  },
  beforeMount () {
    // 自定义AMapUI 绘制引擎的构造类
    this.$nextTick(() => {
      this.initMyAMapUI()
    })
  },
  methods: {
    // 自定义AMapUI 绘制引擎的构造类
    initMyAMapUI () {
      if (this.pointSimplifierIns) {
        // 已生成海量点实例时，不需再重新生成
        return
      }
      const _this = this
      setTimeout(() => {
        window.AMapUI.load(['ui/misc/PointSimplifier'], function (PointSimplifier) {
          if (!PointSimplifier.supportCanvas) {
            alert('当前环境不支持 Canvas！')
            return
          }
          // 海量点基本配置
          _this.initPointSimplifier(PointSimplifier)
        })
      }, 1000)
      //                let vm = this;
      //                AMapUI.load(['ui/misc/PointSimplifier', 'lib/$'], function(PointSimplifier, $) {
      //                    if (!PointSimplifier.supportCanvas) {
      //                        alert('当前环境不支持 Canvas！');
      //                        return;
      //                    }
      //                    /**
      //                     * 自定义的分组绘制引擎，仅作示例,功能类似于 PointSimplifier.Render.Canvas.GroupStyleRender
      //                     * @param {PointSimplifier} pointSimplifierIns 关联的PointSimplifier实例
      //                     * @param {Object} opts   配置
      //                     */
      //                    // 继承自默认的Canvas引擎（https://webapi.amap.com/ui/1.0/ui/misc/PointSimplifier/render/canvas.js）
      //                    utils.inherit(MyCanvasRender, PointSimplifier.Render.Canvas);
      //
      //                    utils.extend(MyCanvasRender.prototype, {
      //                        linePoints: function (ctx, list, styleOptions, pixelRatio) {
      //                            if (styleOptions.content) {
      //                                let lineMethod = this.getLineMethodByContent(styleOptions.content);
      //                                if (lineMethod) {
      //                                    let count = 0;
      //                                    for (let width = styleOptions.width, height = styleOptions.height, offset = this.getOffset(styleOptions), len = list.length, i = len - 1; i >= 0; i--) {
      //                                        let x = list[i].x;
      //                                        let y = list[i].y;
      //                                        lineMethod.call(this, ctx, (x + offset[0]) * pixelRatio, (y + offset[1]) * pixelRatio, width * pixelRatio, height * pixelRatio, list[i].idx);
      //                                        count++
      //                                    }
      //                                    return count
      //                                }
      //                            }
      //                        },
      //                        /**
      //                         * 重新实现点的绘制方法
      //                         * @param  {number} zoom       当前的地图级别
      //                         * @param  {Array} activePoints 可以正常绘制的点
      //                         * @param  {Array} shadowPoints 空间被占用的点
      //                         */
      //                        renderNormalPoints: function (zoom, activePoints, shadowPoints) {
      //                            // 先按默认逻辑处理shadowPoints
      //                            MyCanvasRender.__super__.renderNormalPoints.call(this, zoom, null, shadowPoints);
      //                            let pointStyle = this.getOption('pointStyle');
      //                            let getPointsGroupKey = this.getOption('getPointsGroupKey');
      //                            let pointStyleGroup = this.getOption('pointStyleGroup');
      //                            let pointSimplifierIns = this.getPointSimplifierInstance();
      //                            let groups = {};
      //
      //                            // 按key分组
      //                            for (let i = 0, len = activePoints.length; i < len; i++) {
      //                                let point = activePoints[i];
      //                                let dataIndex = point.idx;
      //                                let dataItem = pointSimplifierIns.getDataItemByIndex(dataIndex);
      //                                let key = getPointsGroupKey.call(this, dataItem, dataIndex);
      //                                if (!groups[key]) {
      //                                    groups[key] = []
      //                                }
      //                                groups[key].push(activePoints[i])
      //                            }
      //                            // 分组绘制
      //                            for (let k in groups) {
      //                                // 继承pointStyle中的默认属性
      //                                let styleOptions = utils.extend({}, pointStyle, pointStyleGroup[k]);
      //                                // 调用父类的绘制函数
      //                                this.drawPointsWithStyleOptions(groups[k], styleOptions);
      //                            }
      //                        }
      //                    });
      // 海量点基本配置
      //                    vm.initPointSimplifier(PointSimplifier);
      //                })
    },
    // 海量点基本配置
    initPointSimplifier (PointSimplifier) {
      const vm = this
      this.pointSimplifierIns = new PointSimplifier({
        map: vm.getMapInstance(),
        // 是否在绘制后自动调整地图视野以适合全部点，默认true
        autoSetFitView: false,
        zIndex: 500,
        // 返回数据项中的经纬度信息
        getPosition: function (item) {
          return [item.longitude, item.latitude]
        },
        // 返回鼠标Hover时显示的Title内容
        getHoverTitle: function (item) {
          return item.clientName
        },
        // 数据项的优先级比较函数 当前活动的最高，然后序号小的高
        compareDataItem: function (a, b, aIndex, bIndex) {
          if (aIndex === vm.curActivePoint.dataIndex) {
            return -1
          }
          if (bIndex === vm.curActivePoint.dataIndex) {
            return 1
          }
          if (aIndex === bIndex) {
            return 0
          }
          return aIndex > bIndex ? 1 : -1
        },
        // 绘制引擎的构造类,Canvas.GroupStyleRender支持样式分组
        renderConstructor: PointSimplifier.Render.Canvas.GroupStyleRender,
        // 采用自定义的分组绘制引擎
        // renderConstructor: MyCanvasRender,
        // 绘制引擎的构造参数
        renderOptions: {
          // 是否绘制位置点,开发调试阶段开启 辅助设定点的绘制区域的偏移
          drawPositionPoint: process.env.NODE_ENV === 'development',
          // 点的样式
          //                        pointStyle:{
          //                            // 点样式创建函数 水滴形状
          //                            content: function (ctx, x, y, width, height, dataIndex) {
          //                                let dataIndexLength = dataIndex.toString().length;
          //                                let curWidth = width;
          //                                if(dataIndexLength === 4){
          //                                    curWidth += width*(8/60)
          //                                }else if(dataIndexLength === 5){
          //                                    curWidth += width*(24/60)
          //                                }
          //                                if(dataIndexLength<=3){
          //                                    ctx.arc(x + width / 2, y + width / 2, width / 2, 0, 2 * Math.PI);
          //                                    ctx.moveTo(x+(curWidth/2-width/5),y+width*19/20);
          //                                    ctx.lineTo(x+(curWidth/2+width/5),y+width*19/20);
          //                                    ctx.arcTo(x+curWidth/2,y+width*19/20,x+curWidth/2,y+width*6/5,width/5);
          //                                    ctx.arcTo(x+curWidth/2,y+width*19/20,x+(curWidth/2-width/5),y+width*19/20,width/5);
          //                                    ctx.closePath();
          //                                }else{
          //                                    ctx.lineJoin="round";
          //                                    ctx.moveTo(x+(curWidth/2-width/5),y+width-2);
          //                                    ctx.lineTo(x+(curWidth/2+width/5),y+width-2);
          //                                    ctx.arcTo(x+curWidth/2,y+width-2,x+curWidth/2,y+width*6/5,width/5);
          //                                    ctx.arcTo(x+curWidth/2,y+width-2,x+(curWidth/2-width/5),y+width-2,width/5);
          //                                    ctx.arc(x+3/7*curWidth,y+width/2,width/2,80/180*Math.PI,260/180*Math.PI);
          //                                    ctx.arc(x+4/7*curWidth,y+width/2,width/2,-80/180*Math.PI,100/180*Math.PI);
          //                                    ctx.closePath();
          //                                }
          //                                // 在源图像上方显示目标图像
          //                                ctx.globalCompositeOperation = 'destination-over';
          //                                let fontSize = (dataIndex=== vm.curActivePoint.dataIndex) ? 64 :42;
          //                                ctx.font=`${Math.round(fontSize*vm.$store.state.per)}px bold`;
          //                                ctx.textAlign = 'center';
          //                                ctx.fillStyle = 'white';
          //                                ctx.fillText(dataIndex + 1, x + curWidth / 2, y + height*5/9)
          //                            },
          //                            offset:['-50%', '-100%'],
          //                            // 宽度
          //                            width: Math.round(60*vm.$store.state.per),
          //                            // 高度
          //                            height: Math.round(66*vm.$store.state.per)
          //                        },
          //                        getPointsGroupKey: function (dataItem, dataIndex) {
          //                            if (dataIndex === vm.curActivePoint.dataIndex) {
          //                                return dataItem.cover ? '2' : '3'
          //                            }
          //                            return dataItem.cover ? '0' : '1'
          //                        },
          //                        // 分组配置
          //                        pointStyleGroup: {
          //                            '0': {
          //                                fillStyle: vm.pointColor.covered
          //                            },
          //                            '1': {
          //                                fillStyle: vm.pointColor.uncover
          //                            },
          //                            '2': {
          //                                // 宽度
          //                                width: Math.round(100*vm.$store.state.per),
          //                                // 高度
          //                                height: Math.round(110*vm.$store.state.per),
          //                                fillStyle: vm.pointColor.covered
          //                            },
          //                            '3': {
          //                                // 宽度
          //                                width: Math.round(100*vm.$store.state.per),
          //                                // 高度
          //                                height: Math.round(110*vm.$store.state.per),
          //                                fillStyle: vm.pointColor.uncover
          //                            }
          //                        },
          // 点的样式
          pointStyle: {
            content: 'circle',
            width: Math.round(36 * vm.$store.state.per),
            height: Math.round(36 * vm.$store.state.per),
            fillStyle: vm.pointColor.covered
          },
          //                        pointHardcoreStyle:{
          //                            content:function(ctx, x, y, width, height){
          //                                ctx.arc(x + width/2, y + height/2, width/6, 0, 2 * Math.PI);
          //                                ctx.closePath()
          //                            },
          //                            width: Math.round(51*vm.$store.state.per),
          //                            height: Math.round(51*vm.$store.state.per),
          //                            fillStyle: "#fff"
          //                        },
          // 绘制样式分组 返回某个数据项的分组Id
          getGroupId: function (item, idx) {
            if (idx === vm.curActivePoint.dataIndex) {
              return (item.cover || item.visitStatus) ? 2 : 3
            }
            return (item.cover || item.visitStatus) ? 0 : 1
          },
          groupStyleOptions: function (gid) {
            if (gid === 2 || gid === 3) {
              // 放大的
              return {
                pointStyle: {
                  width: Math.round(60 * vm.$store.state.per),
                  height: Math.round(60 * vm.$store.state.per),
                  fillStyle: gid === 2 ? vm.pointColor.covered : vm.pointColor.uncover
                },
                pointHardcoreStyle: {
                  content: function (ctx, x, y, width, height) {
                    const img = new Image()
                    img.src = require('../assets/images/img/marker.png')
                    ctx.drawImage(img, x + width * 18 / 64, y + height * 18 / 64, width * 28 / 64, height * 28 / 64)
                  },
                  width: Math.round(64 * vm.$store.state.per),
                  height: Math.round(64 * vm.$store.state.per)
                }
              }
            } else {
              return {
                pointStyle: {
                  fillStyle: gid === 0 ? vm.pointColor.covered : vm.pointColor.uncover
                }
              }
            }
          },
          // 四叉图点样式，不让显示TopN区域样式
          topNAreaStyle: {
            fillStyle: 'rgba(255,255,255,0)'
          }
        }
      })
      // 监听事件,当点被点击时,获取当前活动点数据
      this.pointSimplifierIns.on('pointClick', function (event, point) {
        vm.setActivePoint(point)
      })
    },
    // 设置海量点数据，绘制海量点
    setMarkerData (list) {
      this.curActivePoint = {} // 清除已点击选择的点
      if (list && list.length > 0) {
        // 是定位获取的数据时，不变化中心点
        if (this.positionArea.districtCode) {
          this.positionArea = {}
        } else {
          // this.mapConfig.center = [list[0].longitude,list[0].latitude];
        }
      }
      this.$nextTick(() => {
        if (this.pointSimplifierIns) {
          this.pointSimplifierIns.setData(list)
        } else {
          // 自定义AMapUI未成功load
          const _this = this
          this.initMyAMapUI()
          setTimeout(function () {
            _this.pointSimplifierIns && _this.pointSimplifierIns.setData(list)
          }, 300)
        }
      })
    },
    // 设置当前活动点 isList 是否是点击列表上的终端触发
    setActivePoint (point, isList) {
      if (point.index !== this.curActivePoint.dataIndex) {
        this.curActivePoint = point.data
        this.curActivePoint.dataIndex = point.index
        this.mapConfig.center = [point.data.longitude, point.data.latitude]
        this.pointSimplifierIns.render()
        // 分发查看详情事件
        this.$emit('viewDetails', this.curActivePoint, isList)
      }
    },
    // 获取map实例
    getMapInstance () {
      return this.$refs.map.$$getInstance()
    },
    // 清除地图上所有多边形覆盖物
    clearPolygons () {
      for (let i = 0, l = this.polygons.length; i < l; i++) {
        this.polygons[i].setMap(null)
      }
    },
    // 行政区域查询，获取查询区域中心点坐标，作为参数获取终端列表
    aMapDistrictSearch (area) {
      const vm = this
      window.AMap.plugin('AMap.DistrictSearch', function () {
        if (!vm.districtSearch) {
          // 创建行政区查询对象
          vm.districtSearch = new window.AMap.DistrictSearch({
            // 不显示商圈
            showbiz: false,
            // 返回行政区边界坐标等具体信息
            extensions: 'base', // all，返回完整行政区边界坐标点, base，不返回
            // 设置查询行政区级别为 区
            level: 'district',
            // 区/县 级别不返回下级行政区
            subdistrict: '0'
          })
        }
        // 执行查询
        vm.districtSearch.search(area.districtCode.toString(), function (status, result) {
          if (status === 'complete') {
            // 设置地图层级
            vm.getMapInstance().setZoom(13)
            // 移动地图中心位置
            vm.mapConfig.center = [result.districtList[0].center.lng, result.districtList[0].center.lat]
            // 触发获取到查询区域中心点坐标消息事件
            vm.$emit('getDistrictCenter', Object.assign(area, {
              lat: result.districtList[0].center.lat,
              lng: result.districtList[0].center.lng
            }))
            // 清除上次结果
            vm.clearPolygons()
            // 获取行政区域边界坐标集合
            const bounds = result.districtList[0].boundaries
            if (bounds) {
              for (let i = 0, l = bounds.length; i < l; i++) {
                // 生成行政区划polygon
                const polygon = new window.AMap.Polygon({
                  map: vm.getMapInstance(),
                  strokeWeight: 1,
                  strokeColor: '#0091ea',
                  fillColor: 'transparent',
                  fillOpacity: 0.1,
                  path: bounds[i],
                  bubble: true
                })
                vm.polygons.push(polygon)
              }
            }
          } else {
            vm.clearPolygons()
            var center = []
            center = [area.centerLongitude, area.centerLatitude]
            vm.mapConfig.center = center

            vm.getMapInstance().setZoom(13)
            vm.$emit('getDistrictCenter', Object.assign(area, {
              lat: area.centerLatitude,
              lng: area.centerLongitude
            }))
          }
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
    .map-wrap{
        width 100%
        height 100%
    }
</style>
<style lang="stylus">
    // 隐藏高德logo与版权
    .amap-logo,.amap-copyright{
        display none !important
    }
    .amap-scalecontrol{
        bottom 2px !important;
    }
    .amap-toolbar,.amap-zoomcontrol,.amap-geolocation-con,.amap-scalecontrol{
        z-index 80 !important
    }
</style>
